// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.view-detail-modal-wrapper .view-itinerary-modal-wrapper {
  height: 100%;
  width: 80vw;
}
.view-detail-modal-wrapper .view-itinerary-modal-wrapper .heading-text {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0.03em;
}
.view-detail-modal-wrapper .view-itinerary-modal-wrapper .guest-details-wrapper {
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 10px 12px;
}
.view-detail-modal-wrapper .view-itinerary-modal-wrapper .guest-details-wrapper span {
  color: #3a3a3a;
  font-size: 16px;
  font-weight: 500;
}
.view-detail-modal-wrapper .view-itinerary-modal-wrapper .guest-details-wrapper .detail-name {
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.03em;
}
.view-detail-modal-wrapper .view-itinerary-modal-wrapper .itinerary-details-wrapper {
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 10px 12px;
}
.view-detail-modal-wrapper .view-itinerary-modal-wrapper .itinerary-details-wrapper p, .view-detail-modal-wrapper .view-itinerary-modal-wrapper .itinerary-details-wrapper span {
  font-size: 18px;
  font-weight: 500;
  color: #3a3a3a;
  margin: 0;
}
.view-detail-modal-wrapper .view-itinerary-modal-wrapper .itinerary-details-wrapper span {
  font-size: 16px;
}
.view-detail-modal-wrapper .view-itinerary-modal-wrapper .view-details-cards-wrapper .view-details-card-wrapper {
  width: fit-content;
  border: 1px solid #ddd;
  border-radius: 6px;
}
.view-detail-modal-wrapper .view-itinerary-modal-wrapper .view-details-cards-wrapper .view-details-card-wrapper .img-wrapper img {
  border-radius: 6px;
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/ViewDetailModal/style.scss"],"names":[],"mappings":"AACI;EACI,YAAA;EACA,WAAA;AAAR;AAEQ;EACI,eAAA;EACA,gBAAA;EACA,sBAAA;AAAZ;AAGQ;EACI,sBAAA;EACA,kBAAA;EACA,kBAAA;AADZ;AAGY;EACI,cAAA;EACA,eAAA;EACA,gBAAA;AADhB;AAIY;EACI,eAAA;EACA,gBAAA;EACA,sBAAA;AAFhB;AAMQ;EACI,sBAAA;EACA,kBAAA;EACA,kBAAA;AAJZ;AAMY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAJhB;AAOY;EACI,eAAA;AALhB;AAUY;EACI,kBAAA;EACA,sBAAA;EACA,kBAAA;AARhB;AAWoB;EACI,kBAAA;AATxB","sourcesContent":[".view-detail-modal-wrapper {\n    .view-itinerary-modal-wrapper {\n        height: 100%;\n        width: 80vw;\n\n        .heading-text {\n            font-size: 22px;\n            font-weight: 700;\n            letter-spacing: 0.03em;\n        }\n\n        .guest-details-wrapper {\n            border: 1px solid #ddd;\n            border-radius: 6px;\n            padding: 10px 12px;\n\n            span {\n                color: #3a3a3a;\n                font-size: 16px;\n                font-weight: 500;\n            }\n\n            .detail-name {\n                font-size: 18px;\n                font-weight: 500;\n                letter-spacing: 0.03em;\n            }\n        }\n\n        .itinerary-details-wrapper{\n            border: 1px solid #ddd;\n            border-radius: 6px;\n            padding: 10px 12px;\n\n            p, span{\n                font-size: 18px;\n                font-weight: 500;\n                color: #3a3a3a;\n                margin: 0;\n            }\n\n            span{\n                font-size: 16px;\n            }\n        }\n\n        .view-details-cards-wrapper {\n            .view-details-card-wrapper {\n                width: fit-content;\n                border: 1px solid #ddd;\n                border-radius: 6px;\n\n                .img-wrapper{\n                    img{\n                        border-radius: 6px;\n                    }\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
